import dedent from 'ts-dedent'
import { ColumnDataType, Provider, WorkflowComponentCodeParams, WorkflowComponentParamType } from '../types'
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent'

class Dump extends SelectSameSchemaWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.dump',
        group: 'Aggregation',
        title: 'ST Dump',
        description: `
    This component explodes multi-part geographies into multiple single-part ones.

    `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery: {
        return dedent`
          WITH parts AS(
            SELECT ST_DUMP(${params.geo}) dump, s.* EXCEPT (${params.geo})
            FROM ${connection.quoteName(params.source as string)} s
          )
          SELECT * EXCEPT (dump)
          FROM parts, UNNEST (dump) ${params.geo}_single`
      }
      case Provider.Postgres: {
        return dedent`
          SELECT single.geom AS ${params.geo}_single , s.*
          FROM ${connection.quoteName(params.source as string)} s,
          LATERAL ST_DUMP(${params.geo}) single`
      }
      case Provider.DatabricksRest: {
        return dedent`
          WITH parts AS(
            SELECT /*+ REPARTITION(40) */ EXPLODE(SEDONA_ST_DUMP(SEDONA_ST_GEOMFROMWKB(${params.geo}))) single_geom,
              s.* EXCEPT (${params.geo})
            FROM ${connection.quoteName(params.source as string)} s
          )
          SELECT /*+ REPARTITION(40, ${params.geo}_single) */
            * EXCEPT (single_geom),
            SEDONA_ST_ASBINARY(single_geom) ${params.geo}_single
          FROM parts`
      }
      default: {
        return null
      }
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.DatabricksRest]
  }
}

export { Dump }
